import { cx } from 'class-variance-authority'
import { HTMLAttributes } from 'react'
import {
  ContainerStyle,
  ContainerVariant,
} from '@/utils/variants/ContainerVariants'

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  variant?: ContainerVariant
}

export default function Container({
  className,
  children,
  variant = 'default',
  ...props
}: ContainerProps) {
  return (
    <div className={ContainerStyle({ variant })} {...props}>
      <div className={cx("-mx-4 px-4 w-full", className)}>{children}</div>
    </div>
  )
}
